import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '8px 16px 12px 16px',
    textAlign: 'center'
  },

  farmLabel: {
    color: theme.palette.secondary.main,
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    opacity: 0.9
  },

  trigger: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    background: 'transparent',
    border: 'none',
    borderRadius: theme.app.borderRadius.sm,
    padding: '8px 12px',
    cursor: 'pointer'
  },

  farmIcon: {
    color: 'rgba(212, 199, 188, 0.8)',
    fontSize: '18px !important',
    flexShrink: 0
  },

  triggerText: {
    color: '#FAFAFA',
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.7
    }
  },

  triggerIcon: {
    color: 'rgba(212, 199, 188, 0.7)',
    fontSize: '18px !important',
    flexShrink: 0
  },

  popoverPaper: {
    borderRadius: 8,
    marginTop: 4,
    minWidth: 220,
    maxWidth: 280,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    fontFamily: theme.typography.fontFamily
  },

  searchContainer: {
    padding: '8px 12px',
    borderBottom: `1px solid ${theme.palette.divider}`
  },

  searchInput: {
    fontSize: 14,
    borderRadius: 6,
    color: theme.palette.primary.main
  },

  searchIcon: {
    fontSize: 18,
    color: theme.palette.primary.main
  },

  farmList: {
    listStyle: 'none',
    margin: 0,
    padding: '4px 0',
    maxHeight: 250,
    overflowY: 'auto' as const
  },

  emptyResult: {
    padding: '16px',
    textAlign: 'center' as const,
    color: theme.palette.text.secondary,
    fontSize: 14
  },

  farmItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: 'transparent',
    border: 'none',
    padding: '10px 16px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },

  farmItemActive: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },

  farmItemHighlighted: {
    backgroundColor: theme.palette.action.hover
  },

  farmItemName: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500
  },

  farmItemLocation: {
    color: theme.palette.text.secondary,
    fontSize: theme.app.typography.span.fontSize,
    fontWeight: 400,
    marginTop: 2
  }
}))
